'use client';
import { NavLink } from '@mantine/core';
import Link from 'next/link';
import type { NAV_ITEMS } from './Sidebar';

// Create a union type for child items
type NavItemChild = {
  label: string;
  path: string;
  icon?: React.ComponentType<{ size: number }>;
};

type NavButtonProps = {
  item: (typeof NAV_ITEMS)[number] | NavItemChild;
  currentPath: string;
  onNavigate?: () => void;
};

const NavButton = ({ item, currentPath, onNavigate }: NavButtonProps) => {
  const isPathActive = (pathToMatch: string) => {
    if (currentPath === pathToMatch) {
      return true;
    }
    return currentPath.startsWith(`${pathToMatch}/`);
  };

  // Check if item has children
  if ('children' in item) {
    const anyChildActive = item.children.some((child) => isPathActive(child.path));
    return (
      <NavLink
        label={item.label}
        leftSection={<item.icon size={24} />}
        childrenOffset={28}
        active={anyChildActive}
        defaultOpened={anyChildActive}
      >
        {item.children.map((child) => (
          <NavButton
            key={child.path}
            item={child}
            currentPath={currentPath}
            onNavigate={onNavigate}
          />
        ))}
      </NavLink>
    );
  }

  // Handle regular nav item with path
  const isActive = isPathActive(item.path);

  return (
    <NavLink
      component={Link}
      href={item.path}
      label={item.label}
      leftSection={'icon' in item && item.icon ? <item.icon size={24} /> : null}
      active={isActive}
      onClick={onNavigate}
    />
  );
};

export default NavButton;
